import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, ButtonToolbar } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { css } from 'glamor';
import ProductProportionList from './ProductProportionList';

const styles = {
  buttonPanel: css({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '0px',
    marginBottom: '0px',
    marginRight: '17px',
    marginLeft: '17px',
  }),
};

class ProductProportionCreateRMModal extends React.Component {
  setGrid = g => {
    this.grid = g;
  };
  handleOnSave = () => {
    if (this.grid) {
      this.props.onSave(this.grid.api.getModel().rowsToDisplay.map(rn => rn.data));
    }
  };

  render() {
    const { title, closeModal, productId, onSave, isSaveDisabled } = this.props;
    return (
      <div>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          CREATE RM
          <ProductProportionList height="60vh" productId={productId} whenGridReady={this.setGrid} />
        </Modal.Body>
        <Modal.Footer>
          <div className={styles.buttonPanel}>
            <ButtonToolbar>
              <Button bsSize="small" bsStyle="danger" type="button" onClick={closeModal}>
                <i className="fa fa-times" />
                &nbsp;
                <Translate value="general.close" />
              </Button>
              <Button
                bsSize="small"
                bsStyle="success"
                type="button"
                onClick={this.handleOnSave}
                disabled={isSaveDisabled}
              >
                <Translate value="general.save" />
                &nbsp;
                <i className="fa fa-arrow-circle-right" />
              </Button>
            </ButtonToolbar>
          </div>
        </Modal.Footer>
      </div>
    );
  }
}

ProductProportionCreateRMModal.defaultProps = {};

ProductProportionCreateRMModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  productId: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  isSaveDisabled: PropTypes.bool.isRequired,
};

export default ProductProportionCreateRMModal;
